import { definition, styles } from "@uesio/ui"
import Icon from "../icon/icon"
import File, { type FileUtilityProps } from "../file/file"

// type instead of interface since we do not extend in order to avoid @typescript-eslint/no-empty-object-type & @typescript-eslint/no-empty-interface
export type FileImageProps = FileUtilityProps

const StyleDefaults = Object.freeze({
  preview: [],
  image: [],
  nofile: [],
  nofileicon: [],
})

const FileImage: definition.UtilityComponent<FileImageProps> = (props) => {
  const { context, fileInfo } = props

  const fileUrl = fileInfo?.url
  // uesio/io.filefield is used by File component directly even though File component is used by more than "filefield". For now, expanding on this to expose
  // support for FileImage, however the css via variants for File & File* components should be discrete and/or exposed another way.
  // TODO: Refactor variants to avoid using uesio/io.filefield for all File related components
  const classes = styles.useUtilityStyleTokens(
    StyleDefaults,
    props,
    "uesio/io.filefield",
  )

  return (
    <File {...props}>
      <div className={classes.preview}>
        {fileUrl ? (
          // eslint-disable-next-line jsx-a11y/alt-text -- TODO See https://github.com/ues-io/uesio/issues/4489
          <img className={classes.image} src={fileUrl} />
        ) : (
          <div className={classes.nofile}>
            <Icon
              className={classes.nofileicon}
              context={context}
              icon="person"
            />
          </div>
        )}
      </div>
    </File>
  )
}

export { StyleDefaults }

export default FileImage
